require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-ldn-ew.json") })
        }
      }, "path---photos-professional-ldn-ew");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-ldn-ew!./.cache/json/photos-professional-ldn-ew.json
// module id = 814
// module chunks = 231608221292675